import React, {useState, useEffect, useRef} from 'react';
import './timer-exercise-demo.css';

const TimerExerciseDemo = ({initialTime, handleStartNextStep}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime); // Час, що залишився
  const [isRunning, setIsRunning] = useState(true); // Статус таймера
  const [progress, setProgress] = useState(0); // Прогрес від 0 до 100
  const canvasDemoRef = useRef(null); // Посилання на canvas для малювання елементів для таймеру
  const intervalRef = useRef(null); // Для збереження id інтервалу
  const startTimeRef = useRef(Date.now()); // Час запуску таймера для розрахунку прогресу
  const timeRemainingRef = useRef(initialTime); // Зберігаємо час залишковий під час паузи

  // Оновлення прогресу в реальному часі (кожну мілісекунду)
  useEffect(() => {
    if (!isRunning) return;

    const updateProgress = () => {
      const elapsedTime = (Date.now() - startTimeRef.current) / 1000; // Час, що пройшов в секундах
      const timeRemaining = Math.max(0, timeRemainingRef.current - elapsedTime); // Час, що залишився
      setTimeLeft(timeRemaining);

      // Обчислення прогресу (від 0 до 100)
      const currentProgress = ((initialTime - timeRemaining) / initialTime) * 100;
      setProgress(currentProgress);

      // Якщо час ще не вичерпано, повторно викликаємо updateProgress
      if (timeRemaining === 0) {
        clearInterval(intervalRef.current); // Зупиняємо інтервал, коли час вичерпано
        setIsRunning(false);
        handleStartNextStep(prev => prev + 1);
      }
    };

    // Почати оновлення прогресу
    intervalRef.current = setInterval(updateProgress, 10); // Оновлюємо кожні 100 мс

    // Очистка функції, коли таймер зупинений
    return () => {
      clearInterval(intervalRef.current); // Очищаємо інтервал при відміні
    };
    // }
  }, [isRunning]);

  useEffect(() => {
    if (!canvasDemoRef.current) return;
    const canvas = canvasDemoRef.current;
    const ctx = canvas.getContext('2d');
    let width = 160;  // Фізичний розмір канвасу на екрані
    let height = 160; // Фізичний розмір канвасу на екрані

    if (window.innerWidth > 355 && window.innerWidth < 376) {
      width = 130;
      height = 130;
    } else if (window.innerWidth <= 355) {
      width = 110;
      height = 110;
    }

    const scale = window.devicePixelRatio || 1; // Множник для масштабування

    // Встановлюємо канвас на фізичний розмір (160px) через CSS
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    // Встановлюємо внутрішні розміри канвасу з урахуванням devicePixelRatio
    canvas.width = width * scale;
    canvas.height = height * scale;

    // Масштабуємо контекст канвасу
    ctx.scale(scale, scale);

    const radius = width / 2;  // радіус в фізичних пікселях
    const startAngle = -Math.PI / 2; // Початковий кут
    const progressColor = '#E5DDFF';
    const endAngle = startAngle + (2 * Math.PI * (progress / 100));

    // Очищаємо попереднє малювання
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Малюємо фон
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 10, 0, 2 * Math.PI);
    ctx.strokeStyle = '#6F525C';
    ctx.lineWidth = 3;
    ctx.stroke();

    // Малюємо прогрес
    ctx.beginPath();
    ctx.arc(radius, radius, radius - 10, startAngle, endAngle);
    ctx.strokeStyle = progressColor;
    ctx.lineWidth = 3;
    ctx.stroke();

    // Малюємо статичне коло
    const staticCircleRadius = 6.15;
    const staticCircleX = radius;
    const staticCircleY = radius - radius + 10;

    ctx.beginPath();
    ctx.arc(staticCircleX, staticCircleY, staticCircleRadius, 0, 2 * Math.PI);
    ctx.fillStyle = '#6F525C';
    ctx.fill();
  }, [progress]);

  return (
    <div className='timer-demo-container'>
      <canvas className='timer-demo-circle'
              ref={canvasDemoRef}
      ></canvas>
      <div
        className={`time-demo-remaining ${isRunning ? 'time-demo-visible' : ''} `}>
        {Math.ceil(timeLeft)}
      </div>
    </div>
  );
};

export default TimerExerciseDemo;
